import { Button as MjButton } from "@mijadesign/mjui-react";
import "@mijadesign/mjui-react/dist/esm/Button/style/css";
import type { CSSProperties, ReactNode } from "react";

interface H5ButtonProps {
  text?: string;
  children?: ReactNode;
  type?: "primary" | "default" | "info" | "warning" | "danger" | "success";
  size?: "large" | "normal" | "small" | "mini";
  shape?: "default" | "square" | "round";
  block?: boolean;
  disabled?: boolean;
  loading?: boolean;
  style?: CSSProperties;
  className?: string;
}

function H5Button({
  text,
  children,
  type = "default",
  size = "large",
  shape = "round",
  block = true,
  style,
  ...rest
}: H5ButtonProps) {
  const buttonShape = shape === "default" ? undefined : shape;

  return (
    <MjButton
      type={type}
      size={size}
      shape={buttonShape}
      style={{
        width: block ? "100%" : undefined,
        ...style,
      }}
      {...rest}
    >
      {children || text || "按钮"}
    </MjButton>
  );
}

export default H5Button;
